import React from "react";
import { View, Text, ScrollView } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { Image } from "expo-image";
import Images from "@/assets/images";
import FlightCard from "./FlightCard";
import { FontFamilies, Typography } from "@/constants/Typography";
import Icons from "@/assets/icons";

export default function WelcomeSlide5() {
  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.contentContainer}
      showsVerticalScrollIndicator={false}
    >
      {/* Title */}
      <Text style={styles.title}>Get refunds from flight delays.</Text>
      {/* Card */}
      <FlightCard
        amount="$273.93"
        title="Flight delay on United Airlines"
        logo={<Image source={Images.logoUnintedAirlines} style={styles.logo} />}
        status={[
          {
            icon: <Icons.NoProof />,
            text: "Landed 1.5h late",
          },
          {
            icon: <Icons.Clock />,
            text: "Paid on Jun 23",
          },
        ]}
      />
      {/* Review box */}
      <View style={styles.reviewBox}>
        <Image source={Images.avatarRv5} style={styles.avatar} />
        <View style={styles.reviewContent}>
          <Text style={styles.stars}>★★★★★</Text>
          <Text style={styles.reviewText}>
            @ron.chin: &quot;Easy process. Good information regarding potential
            or existing class action litigation complaints.&quot;
          </Text>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontFamily: FontFamilies.InterTight.Medium,
    fontSize: 36,
    color: "#fff",
    textAlign: "left",
    width: "100%",
    paddingHorizontal: 16,
    marginBottom: 24,
  },
  logo: {
    width: 64,
    height: 64,
  },
  reviewBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 12,
    marginTop: 24,
    width: "90%",
    borderWidth: 1,
    borderColor: "#FFFFFF33",
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
    marginRight: 12,
  },
  reviewContent: {
    flex: 1,
  },
  stars: {
    color: "#FFD700",
    ...Typography.body.medium,
    marginBottom: 2,
  },
  reviewText: {
    color: "#fff",
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 13,
  },
});
